import React, { useEffect, useContext } from 'react'
import { VStack, Heading, Text, Box, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../config/colorTokens'
import { motion, AnimatePresence } from 'framer-motion'
import Section from '../components/Section'
import achievements from '../data/achievements'
import Achievement from '../components/Achievements/Achievement'
import loaderContext from "../context/loaderContext";
import Loader from '../components/Loader/Loader'
import SEOHead from "../components/SEOHead";
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionVStack = motion(VStack)
const MotionBox = motion(Box)

const Achievements = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])
    return (
        <div>
            <SEOHead 
                title="Achievements | Prasoon Soni"
                description="Awards and achievements of Prasoon Soni - Recognition, competitions, hackathons, and accomplishments in software development and technology."
                path="/achievements"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                <Section id="achievement">
                    <VStack align="stretch" spacing={4} p={4}>
                        <MotionBox variants={heroVariants}>
                            <VStack align="start" spacing={3} mb={4}>
                                <Heading w="full">Achievements</Heading>
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    color={t.textSubtle}
                                    fontWeight="light"
                                    maxW="2xl"
                                >
                                    Moments of excellence and recognition.
                                </Text>
                                <Box
                                    h="2px"
                                    w="60px"
                                    bgGradient={t.accentGradient}
                                    borderRadius="full"
                                    mt={1}
                                />
                            </VStack>
                        </MotionBox>
                        <MotionVStack
                            align="stretch"
                            spacing={4}
                            variants={containerVariants}
                        >
                            {achievements.map((achievement) => {
                                return <Achievement
                                    key={achievement.id}
                                    title={achievement.title}
                                    description={achievement.description}
                                    logo={achievement.logo}
                                    certificate={achievement.certificate}
                                    date={achievement.date}
                                    variants={itemVariants}
                                />
                            })}
                        </MotionVStack>
                    </VStack>
                </Section>
                </MotionVStack>}
            </AnimatePresence>
        </div >
    )
}

export default Achievements
